import VerticalProductCard from 'components/commons/products/VerticalProductCard';
import React from 'react';
import styled from 'styled-components';
import { Column } from 'styled/alignment/Column';
import breakpoints from 'theme/breakpoints';
import colors from 'theme/colors';
import fonts from 'theme/fonts';
import { ShoppingBag } from 'react-feather';

export default function ProductsForSale({ data, onProductClick = () => false }) {
    const products = data?.filter((el) => el.type === 'product') || [];

    if (!products.length) return null;

    return (
        <Container>
            <SectionHeader>
                <HeaderLeft>
                    <HeaderIcon>
                        <ShoppingBag size={14} color={colors.primaryLight} />
                    </HeaderIcon>
                    <SectionTitle>Produtos à venda</SectionTitle>
                </HeaderLeft>
                <CountBadge>{products.length}</CountBadge>
            </SectionHeader>

            <ProductsTrack>
                {products.map((el) => (
                    <ProductItem key={el.id}>
                        <VerticalProductCard
                            data={el}
                            onProductClick={() => onProductClick()}
                        />
                    </ProductItem>
                ))}
            </ProductsTrack>
        </Container>
    );
}

const Container = styled(Column)`
    width: 100%;
    gap: 12px;
`;

const SectionHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const HeaderLeft = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

const HeaderIcon = styled.div`
    width: 28px;
    height: 28px;
    border-radius: 8px;
    background: rgba(79, 134, 247, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

const SectionTitle = styled.p`
    font-size: ${fonts.sizes.small};
    font-weight: ${fonts.weight.bold};
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: ${colors.night};
    margin: 0;
`;

const CountBadge = styled.span`
    font-size: ${fonts.sizes.mini};
    font-weight: ${fonts.weight.bold};
    color: ${colors.primaryLight};
    background: rgba(79, 134, 247, 0.08);
    padding: 2px 10px;
    border-radius: 8px;
    min-width: 24px;
    text-align: center;
`;

const ProductsTrack = styled.div`
    width: 100%;
    display: flex;
    gap: 12px;
    overflow-x: auto;
    padding-bottom: 4px;

    &::-webkit-scrollbar {
        height: 3px;
    }
    &::-webkit-scrollbar-track {
        background: transparent;
    }
    &::-webkit-scrollbar-thumb {
        background: rgba(0, 0, 0, 0.08);
        border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: rgba(0, 0, 0, 0.15);
    }

    @media screen and (min-width: ${breakpoints.md}) {
        flex-wrap: wrap;
        overflow-x: visible;
    }
`;

const ProductItem = styled.div`
    flex-shrink: 0;
    width: 156px;

    & > div {
        width: 100%;
    }

    @media screen and (min-width: ${breakpoints.md}) {
        width: 172px;
    }
`;
